import { Component, OnInit, ChangeDetectionStrategy, ElementRef } from '@angular/core';
import { ThemePalette } from '@angular/material/core';

/**
 * Indicatorを表示するときのオプション
 */
export interface ProgressOptions {
  color?: string;
  diameter?: number;
  strokeWidth?: number;
}

@Component({
  selector: 'app-progress',
  template: `
    <mat-progress-spinner
      mode="indeterminate"
      [color]="color"
      [diameter]="diameter"
      [strokeWidth]="strokeWidth"
    >
    </mat-progress-spinner>
  `,
  styles: [
    `
      .app-progress {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ProgressComponent {

  /**
   * Indicatorの色
   */
  color?: string;

  /**
   * Indicatorの直径
   */
  diameter?: number;

  /**
   * Indicatorの線の太さ
   */
  strokeWidth?: number;

  constructor(
    private elem: ElementRef
  ) {
    let options: ProgressOptions = { 
      color: '#8259a5', 
      diameter: 80, 
      strokeWidth: 8 
    };
    this.color = options.color;
    this.diameter = options.diameter;
    this.strokeWidth = options.strokeWidth;
  }

  ngAfterViewInit(){
    if(!!this.color){
      const element = this.elem.nativeElement;
      const circles = element.querySelectorAll("circle");
      circles.forEach((circle: any) => {
        circle.style.stroke = this.color;
      });
    }
  }

  ngOnInit(): void {
  }
  
}
